import React, { useEffect } from 'react';
import { RocketImage } from 'src/assets/images';
import { publicSiteUrl } from 'src/common';
import { Button } from 'src/components';
import { ButtonParamType, DefaultButtonStyle } from 'src/components/button/button';
import TealiumEvents from 'src/helpers/tealium-events';
import './pending-app-complete.scss';

export const PendingAppComplete = () => {
  useEffect(() => {
    TealiumEvents.completedApplicationView();
  }, []);

  return (
    <article className="pending-app-container-legacy">
      <img src={RocketImage} alt="Rocket"></img>
      <h1>All Done!</h1>
      <p>We'll email you soon.</p>
      <Button
        buttonStyle={DefaultButtonStyle()
          .hasPrimaryAction()
          .isMediumSize()
          .build()}
        buttonParams={{
          type: ButtonParamType.NormalButton,
          onClick: () => {
            TealiumEvents.completedApplicationExit();
            window.location.href = publicSiteUrl;
          },
        }}
        className="long-button"
        automationid="Revamp_Setup_Completion_Cancel_Button"
      >
        Close
      </Button>
    </article>
  );
};
